import React from "react";
import Grid from "@mui/material/Grid";
import {
  Paper
} from "@mui/material";
import ReusableDataGrid from "../../components/Tickets";
import axios from "axios";
import { useParams } from "react-router-dom";

const SystemTickets = () => {
    const {system} = useParams();

  const [data, setData] = React.useState([]);

  const getTickets = () => {
    axios(`${process.env.REACT_APP_API_URL}/support-management/ticket/client/${system}`)
      .then((response) => {
        console.log(response.data);
        setData(response.data.tickets.map((ticket) => {
          return {
            id: ticket._id,
            ticketId: ticket.ticketId,
            subject: ticket.subject,
            category: ticket.category,
            priority: ticket.priority,
            createdAt: ticket.createdAt,
            updatedAt: ticket.updatedAt,
            status: ticket.status,
          };
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  }

  React.useEffect(() => {
    getTickets();
  }, [system]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          
          <ReusableDataGrid data={data} />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default SystemTickets;
